var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStLucia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0342C24.8366 32.0342 32 24.8707 32 16.0342C32 7.19762 24.8366 0.0341797 16 0.0341797C7.16344 0.0341797 0 7.19762 0 16.0342C0 24.8707 7.16344 32.0342 16 32.0342Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0874 21.5998H21.9135L16.0005 7.68677L10.0874 21.5998Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1416 20.2081L15.9997 11.4325L19.8577 20.2081H12.1416Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0874 21.5994H21.9135L16.0005 16.0342L10.0874 21.5994Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStLucia);
export default __webpack_public_path__ + "static/media/st-lucia.c5335aa5.svg";
export { ForwardRef as ReactComponent };